import classnames from 'classnames'
import React from 'react'

import { Table } from '../Table'
import FinancialsTableRow from './FinancialsTableRow'
import {
  FinancialsColumnDefinition,
  FinancialsRowDataType,
  FinancialsSubColumnDefinition,
  FinancialsSubRowDataType,
} from './types'

type FinancialsTableProps<
  RowDataType extends FinancialsRowDataType,
  ColumnDefinition extends FinancialsColumnDefinition<RowDataType>,
  SubColumnDefinition extends FinancialsSubRowDataType,
> = {
  tableHead?: React.ReactNode
  tableFooter?: React.ReactNode
  data: RowDataType[]
  columns: ColumnDefinition[]
  subColumns?: Record<string, FinancialsSubColumnDefinition<SubColumnDefinition>[]>
  isTableFixed?: boolean
  onVisibilityChange: (area: string, visibility: boolean) => void
}

export default function FinancialsTable<
  RowDataType extends FinancialsRowDataType,
  ColumnDefinition extends FinancialsColumnDefinition<RowDataType>,
  SubColumnDefinition extends FinancialsSubRowDataType,
>({
  tableHead,
  tableFooter,
  columns,
  subColumns,
  data,
  isTableFixed = true,
  onVisibilityChange,
}: FinancialsTableProps<RowDataType, ColumnDefinition, SubColumnDefinition>) {
  return (
    <Table className={classnames('financials-table leading-4 [overflow-anchor:none]', { 'table-fixed': isTableFixed })}>
      {tableHead}
      {data.map((row, index) => (
        <FinancialsTableRow
          key={row.id ?? row.label}
          data={row}
          columns={columns}
          subColumns={subColumns}
          onVisibilityChange={onVisibilityChange}
          isFirst={index === 0}
          isLast={index === data.length - 1}
        />
      ))}
      {tableFooter}
    </Table>
  )
}
